import React from "react";
import css from "./carosalcard.module.scss";
import { useMediaQuery } from "@mui/material";
import bg_cao from "../asset/bg_cao.png";

function CarosalCard({
  type,
  title,
  description,
  image,
  buttonTitle,
  buttonClick,
}) {
  const style = {
    background: `url(${bg_cao})`,
    backgroundBlendMode: "plus-lighter",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    backgroundSize: "cover",
    backgroundRepeat: "noRepeat",
  };
  const isLargeScreen = useMediaQuery("(min-width:767px)");
  return (
    <div className={css.cardWrap} style={style}>
      <div className={css.cardText}>
        <div className={css.type}>{type}</div>
        <div className={css.title}>{title}</div>
        <div className={css.description}>{description}</div>
        <button
          id={css.btn_join}
          onClick={() => {
            if (buttonClick) {
                console.log("ai clicked")
              buttonClick(true);
            }
          }}
        >
          {buttonTitle}
        </button>
      </div>
      {isLargeScreen && (
        <div className={css.cardImage}>
          <img src={image} alt="caroslImage" />
        </div>
      )}
    </div>
  );
}

export default CarosalCard;
